/** @jsx jsx */
import { jsx, Styled } from "theme-ui"
import { Fragment } from "react"
import { useStaticQuery, graphql } from "gatsby"
import BlockContent from "../../molecules/BlockContent"
import { useTranslation } from "react-i18next"

import SocialLinks from "../../molecules/SocialLinks"
import JoinInForm from "../../molecules/JoinInForm"

import { getResolvedLocale, getDataForLocale } from "../../../utils/i18n"

const JoinIn = () => {
  const { i18n } = useTranslation()
  const { sanityJoinIn, sanityMisc } = useStaticQuery(query)
  const resolvedLocale = getResolvedLocale(i18n)

  const joinInData = getDataForLocale(sanityJoinIn, resolvedLocale.config.code)
  const sanityMiscData = getDataForLocale(sanityMisc, resolvedLocale.config.code)
  
  const { title, _rawBody, _rawAgreement } = joinInData
  const { _rawName, _rawEmail, _rawSubmit } = sanityMiscData

  return (
    <Fragment>
      <section>
        <h1 sx={{ variant: "styles.root.h3", mb: 5 }}>{title}</h1>
        <Styled.root>
          <BlockContent blocks={_rawBody} />
        </Styled.root>
        <SocialLinks sx={{ mt: 5 }} />
      </section>
      <section sx={{ mt: 6, mb: [6, 8] }}>
        <Styled.root>
          <JoinInForm
            agreement={<BlockContent blocks={_rawAgreement} />}
            name={_rawName}
            email={_rawEmail}
            submit={_rawSubmit}
          />
        </Styled.root>
      </section>
    </Fragment>
  )
}

export default JoinIn

const query = graphql`
  query JoinInModule {
    sanityJoinIn {
      id
      title {
        ...StringAllLanguages
      }
      _rawBody(resolveReferences: { maxDepth: 5 })
      _rawAgreement(resolveReferences: { maxDepth: 5 })
    }

    sanityMisc {
      _rawName(resolveReferences: { maxDepth: 5 })
      _rawEmail(resolveReferences: { maxDepth: 5 })
      _rawSubmit(resolveReferences: { maxDepth: 5 })
    }
  }
`
